var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "large / not_found"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64 119C94.3757 119 119 94.3759 119 64.0002C119 33.6246 94.3757 9.00024 64 9.00024C33.6243 9.00024 9 33.6246 9 64.0002C9 94.3759 33.6243 119 64 119Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M19.5059 78.6543C15.6991 83.6534 18.8771 90.8884 25.1339 91.467L95.5311 97.9776C101.788 98.5562 106.239 92.0267 103.413 86.4143L73.4232 26.8413C70.7649 21.5607 63.4946 20.8884 59.9129 25.5919L19.5059 78.6543Z",
    fill: "#FDA22B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5733",
    x: 61.2009,
    y: 42.0802,
    width: 7.96524,
    height: 30.9601,
    rx: 3.98262,
    transform: "rotate(5.28385 61.2009 42.0802)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5734",
    x: 57.9182,
    y: 77.5798,
    width: 7.96524,
    height: 7.96524,
    rx: 3.98262,
    transform: "rotate(5.28385 57.9182 77.5798)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1429",
    cx: 64.0001,
    cy: 101.535,
    rx: 23.0181,
    ry: 1.53467,
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1feada1b2694c4a226921317f0e49d11.svg";
export { ForwardRef as ReactComponent };